<script>
	// Stores
	import CompetitionStore from '@/Stores/Sport/CompetitionStore.js';
	import MarketGroupSetStore from '@/Stores/Sport/MarketGroupSetStore.js';
	// Services
	import { getUrlParameter, setUrlParameter, paginationBuilder } from '@/Services/Helpers.js';
	// Components
	import Loading from '@/Components/Loading.svelte';
	import Pagination from '@/Components/Pagination.svelte';
	// Partials
	import UpdateCompetition from '@/Partials/Sport/Markets/Competitions/_UpdateCompetition.svelte';

	export let sportId;

	$: links =
		$CompetitionStore &&
		!$CompetitionStore.id &&
		$CompetitionStore.id !== null &&
		paginationBuilder(CompetitionStore.getPagination());
	$: sportId && setup();

	let pageNo = getUrlParameter('page') || 1;
	let loading;

	function changePage(e) {
		if (e) {
			pageNo = e.detail.page;
			getCompetitions();
			setUrlParameter('page', pageNo);
		}
	}

	function setup() {
		getCompetitions();
		getMarketGroupSets();
	}

	function getCompetitions() {
		loading = CompetitionStore.getCompetitionsForSport(sportId, {
			size: 50,
			number: pageNo
		});
	}

	function getMarketGroupSets() {
		loading = MarketGroupSetStore.getMarketGroupSetsForSport(sportId);
	}
</script>

{#await loading}
	<Loading />
{:then}
	<div class="overflow-x-auto rounded">
		<table class="w-full whitespace-nowrap">
			<thead>
				<tr class="text-xs text-left text-gray-500 uppercase">
					<th class="px-6 pt-5 pb-4 font-medium">Competition</th>
					<th class="px-6 pt-5 pb-4 font-medium">Market Group Set</th>
					<th class="w-px px-6 pt-5 pb-4 font-medium text-right" />
				</tr>
			</thead>
			<tbody class="bg-white">
				{#if !$CompetitionStore.count()}
					<tr>
						<td class="px-6 py-4 text-center border-t" colspan="3"> No Competitons found. </td>
					</tr>
				{:else}
					{#each $CompetitionStore.sortBy('id').all() as competition (competition.id)}
						<UpdateCompetition {competition} />
					{/each}
				{/if}
			</tbody>
		</table>
	</div>
	<Pagination {links} on:click={changePage} className="my-3" />
{/await}
